import { Box, Button, Heading, Text, useToast } from '@chakra-ui/react'
import { environments } from 'environments/environments'
import { useRef, useState } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { validateCaptcha } from 'services/auth'

export function ValidateRecaptcha({ setShowRepactha }: any) {
    const recaptchaRef = useRef<ReCAPTCHA>(null)
    const { CAPTCHA_SITE_KEY } = environments
    const [captcha, setCaptcha] = useState('')
    const toast = useToast()

    const validateForgotCaptcha = async () => {
        if (captcha) {
            validateCaptcha(captcha)
                .then(() => {
                    setShowRepactha(false)
                })
                .catch(() => {
                    toast({
                        title: 'Erro!',
                        description:
                            'Por favor, confirme que você não é um robô.',
                        position: 'bottom-left',
                        status: 'error',
                        isClosable: true,
                        variant: 'solid-error'
                    })

                    recaptchaRef.current?.reset()
                })

            return
        }

        toast({
            title: 'Erro!',
            description: 'Por favor, confirme que você não é um robô.',
            position: 'bottom-left',
            status: 'error',
            isClosable: true,
            variant: 'solid-error'
        })
    }

    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                height="100vh"
            >
                <Heading my="4">Deseja Visualizar Contrato?</Heading>
                <Text mb="4">
                    Tenha acesso a todas informações do seu contrato
                </Text>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={CAPTCHA_SITE_KEY}
                    onChange={e => e && setCaptcha(e)}
                />
                <Button
                    colorScheme="primary"
                    size="md"
                    mt="4"
                    onClick={validateForgotCaptcha}
                >
                    Visualizar
                </Button>
            </Box>
        </>
    )
}
